<template>
    <!--    <div class="process-card">-->
    <div :class="['card-basis', resultCard && 'result-card']">
        <!--向外展出的线-->
        <div v-if="cardData.placement && cardData.placement.length" class="connect-line">
            <div v-for="item in cardData.placement" :class="['line', item]"></div>
        </div>
        <div v-if="resultCard" class="result-icon"></div>
        <div class="card-content-data">
            <div class="content-data-layout">
                <div class="content-data-layout-left">
                    <!--卡片标题-->
                    <div class="card-title">
                        {{cardData.title || ''}}
                        <p-tooltip
                                v-show="cardData.tooltip"
                                placement="right-start"
                                trigger="hover">
                            <div class="tip-info" slot="content">{{cardData.tooltip || ''}}</div>
                            <p-icon class="help-icon" type="ios-help-outline" transfer="true"></p-icon>
                        </p-tooltip>
                    </div>
                    <!--卡片计算的钱-->
                    <p-tooltip
                            v-show="cardData.data"
                            placement="bottom-end"
                            trigger="hover">
                        <div class="card-data">{{cardData.data || ''}}</div>

                        <div class="tip-info" slot="content">{{cardData.data || ''}}</div>
                    </p-tooltip>
                </div>
                <div class="content-data-layout-chart" v-if="pieData && pieData.length">
                    <div :id="chartName" class="pie"></div>
                </div>
            </div>
            <!--卡片-对外展示的计算数据-->
            <div class="card-compute-data">
                <div class="compute-data" v-for="(index, item) in cardData.computeData" :key="index">
                    <div class="compute-data-label">{{item.label}}</div>
                    <div v-if="item.trend" :class="['compute-data-icon', item.trend || '']"></div>
                    <div :style="item.itemStyle" :class="['compute-data-value']">{{item.value || ''}}</div>
                </div>
            </div>
        </div>
    </div>
    <!--    </div>-->

</template>

<script>
    // 引入 ECharts 主模块
    import echarts from 'echarts'

    let chartOptions = {
        tooltip: {
            width: '114px',
            height: '86px',
            backgroundColor: '#EDF6FF',
            textStyle: {
                color: '#000',
                lineHeight: 14,
                fontSize: 10
            },
            position: ['100%', '-17'],
            extraCssText: 'box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.2);opacity: 0.9;padding: 5px 16px;',
        },
        series: [{
            type: 'pie',
            radius: ['70%', '100%'],
            hoverAnimation: false,
            label: {
                show: false,
                position: 'center'
            },
            data: []
        }]
    }
    export default {
        name: "index",
        props: {
            cardData: {
                type: Object,
                default: function () {
                    return {}
                }
            },
            resultCard: {
                type: Boolean,
                default: false
            },
            pieData: {
                type: Array,
                default: function () {
                    return []
                }
            },
        },
        data() {
            return {
                chartName: `chart-${new Date().getTime()}`
            }
        },
        // vue1.0生命周期，类似mounted
        // compiled() {
        //     if (this.cardData && this.cardData.pieData && this.cardData.pieData.length) {
        //         setTimeout(() => {
        //             this.initChart()
        //         })
        //     }
        // },
        watch: {
            'pieData': {
                deep: true,
                handler(newValue, oldValue) {
                    if (newValue && newValue.length) {
                        this.initChart()
                    }
                }
            }
        },
        methods: {
            initChart() {
                let myChart = echarts.init(document.getElementById(this.chartName));
                chartOptions.series[0].data = this.cardData.pieData || []
                chartOptions.tooltip.formatter = this.formatter
                myChart.setOption(chartOptions);
                console.log("myChart==", myChart)
            },
            formatter(parmas) {
                let pieData = this.cardData.pieData
                let str = ''
                pieData.forEach((item) => {
                    str += '<div style="margin-top: 5px;height:14px;font-size: 10px;">' + parmas.marker.replace(/#(\w+)/, item.itemStyle.color) + "" + item.name + ':\n\n\n\n' + item.data + '\n\n(' + item.value + "%)</div>";
                })
                return str;
            }
        }
    }
</script>

<style lang="less" scoped>
    .card-basis {
        width: 0;
        /*min-width: 260px;*/
        /*min-width: 30%;*/
        min-height: 95px;
        border: 1px solid #DBDEE7;
        border-radius: 4px;
        position: relative;
        display: inline-block;
        margin: 10px;
        flex: 1;

        .result-icon {
            width: 24px;
            height: 24px;
            background-image: url("//m.360buyimg.com/img/jfs/t1/129699/7/4074/521/5f06b65cEecf79719/94f50fff29043528.png");
            background-size: 100%;
            background-position: center;
            position: absolute;
            top: 50%;
            margin-top: -12px;
            left: -18px;
        }


        .card-content-data {
            padding: 9px 21px;

            .content-data-layout {
                display: flex;
                flex-direction: row;
                justify-content: space-between;

                &-left {
                    width: 70%;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;

                    .card-title {
                        width: 100%;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        font-size: 12px;
                        font-family: PingFangSC-Medium;
                        color: #464C5B;
                        line-height: 17px;

                        .tip-info {
                            min-width: 40px !important;
                            white-space: break-spaces !important;
                        }

                        .help-icon {
                            font-size: 14px;
                        }
                    }

                    .card-data {
                        width: 100%;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        font-size: 20px;
                        color: #464C5B;
                        line-height: 22px;
                        margin-top: 10px;
                        font-family: Arial-BoldMT;
                        font-weight: bold;
                    }
                }

                &-chart {
                    width: 30%;
                    /*background-color: #00AAF3;*/
                    /*background-color: #00AAF3;*/
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    .pie {
                        width: 90%;
                        height: 90%;
                    }
                }
            }

            .card-compute-data {
                /*width: 100%;*/
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                margin-top: 5px;

                .compute-data {
                    /*padding-right: 20px;*/
                    display: flex;
                    flex-direction: row;

                    &-label {
                        font-size: 12px;
                        color: #7C8394;
                        font-family: PingFangSC-Regular;
                        white-space: nowrap;
                        line-height: 16px;
                        line-height: 17px;
                    }

                    &-icon {
                        margin-top: 5px;
                        margin-left: 4px;
                    }

                    .up {
                        width: 8px;
                        height: 6px;
                        background-image: url("//m.360buyimg.com/img/jfs/t1/130718/24/4027/140/5f05a8b4Edfc17adb/acca475fabf685f3.png");
                        background-size: 100%;
                    }

                    .down {
                        width: 8px;
                        height: 6px;
                        background-image: url("//m.360buyimg.com/img/jfs/t1/130808/35/4009/338/5f05a8b4E541bae35/ebcb91fb3a9fc127.png");
                        background-size: 100%;
                    }

                    &-value {
                        font-size: 14px;
                        margin-left: 3px;
                        line-height: 15px;
                        margin-top: 2px;

                    }
                }

                :last-child {
                    padding-right: 0;
                }
            }
        }
    }

    .result-card {
        background-color: #EDF6FF;
    }

    .connect-line {

        .line {
            width: 1px;
            height: 15px;
            background-color: #DBDEE7;
        }

        .top-left {
            position: absolute;
            left: 34px;
            margin-top: -15px;
        }

        .top {
            position: absolute;
            left: 50%;
            margin-top: -15px;
        }

        .top-right {
            position: absolute;
            right: 34px;
            margin-top: -15px;
        }

        .bottom-left {
            position: absolute;
            bottom: -15px;
            left: 34px;
        }

        .bottom {
            position: absolute;
            bottom: -15px;
            left: 50%;
        }

        .bottom-right {
            position: absolute;
            bottom: -15px;
            right: 34px;
        }

    }
    .pop-tooltip-rel {
        width: 100%;
    }
</style>
<style>
    .pop-tooltip-rel {
        width: 100%;
    }
</style>



// WEBPACK FOOTER //
// index.vue?0c82b3a8